import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { computed } from "vue";
import {
  appStore,
  artifactApiStore,
  artifactSaveStore,
  artifactStore,
  permissionStore,
  viewsStore,
} from "@/hooks";
import { FlexBox, TextButton } from "@/components/common";


/**
 * Displays artifact buttons.
 */
const __default__ = {
  name: "ArtifactButtons",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const displayActions = computed(() =>
  permissionStore.isAllowed("project.edit_data")
);

const artifact = computed(() => artifactStore.selectedArtifact);

return (_ctx: any,_cache: any) => {
  return (artifact.value)
    ? (_openBlock(), _createBlock(_unref(FlexBox), { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(_unref(TextButton), {
            text: "",
            label: "Tree",
            icon: "view-tree",
            "data-cy": "button-artifact-tree",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(viewsStore).addDocumentOfNeighborhood(artifact.value)))
          }),
          _createVNode(_unref(TextButton), {
            text: "",
            label: "Expand",
            icon: "code",
            "data-cy": "button-artifact-body",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(appStore).openDetailsPanel('displayArtifactBody')))
          }),
          (displayActions.value)
            ? (_openBlock(), _createBlock(_unref(TextButton), {
                key: 0,
                text: "",
                label: "Edit",
                icon: "edit",
                "data-cy": "button-artifact-edit",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(artifactSaveStore).openPanel({})))
              }))
            : _createCommentVNode("", true),
          (displayActions.value)
            ? (_openBlock(), _createBlock(_unref(TextButton), {
                key: 1,
                text: "",
                loading: _unref(artifactApiStore).deleteLoading,
                label: "Delete",
                icon: "delete",
                "data-cy": "button-artifact-delete",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(artifactApiStore).handleDelete(artifact.value)))
              }, null, 8, ["loading"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})